import React, { useMemo, } from "react";
import {
  AppPage,
  MimaButton,
  MimaTable,
} from "../../components";
import constant from "../../utils/constant";
import { downloadXlsx2 } from "../../utils/download";


const BankAccountList = ({
  loading,
  wallets,
  walletBalance,
  setCurrencyCode,
  currencyCode,
  goToSpecificWallet,
  isLoading,
  data,
  isFetching,
  limit,
  onLimitChange,
  currentPage,
  setCurrentPage,
  setSearchQuery,
}) => {

  const tableData = useMemo(() => {
    if (data?.status === constant.Success) {
      return data?.data?.bankAccounts || [];
    }
    return [];
  }, [data]);

  const tableColumns = [
    {
      Header: "Account Name",
      accessor: "accountName",
    },
    {
      Header: "Account Number",
      accessor: "accountNumber",
    },
    {
      Header: "Bank",
      accessor: "bank",
    },
    {
      Header: "Business Owner",
      accessor: "users",
      Cell: ({ cell }) => {
        const users = cell.value;
        return <span>{`${users[0]?.firstname} ${users[0]?.lastname}`}</span>;
      },
    },
    {
      Header: "Phone number",
      accessor: "business",
      Cell: ({ cell }) => {
        const business = cell.value;
        const users = cell.row.original?.users;
        return <span>{`${business?.businessMobile} / ${users[0]?.mobile}`}</span>;
      },
    },
    {
      Header: "Email",
      // accessor: "business",
      Cell: ({ cell }) => {
        const business = cell.row.original?.business;
        return <span>{business?.email} </span>;
      },
    },
    {
      Header: "Status",
      // accessor: "business",
      Cell: ({ cell }) => {
        const status = cell.row.original?.business?.status;

        return <span className={`status ${status === "ACTIVE"
          ? "status__green"
          : status === "INACTIVE"
            ? "status__grey"
            : status === "BLOCKED"
              ? "status__red"
              : "status__dark__yellow"
          }`}>{status} </span>;
      },
    },

    {
      Header: "KYC Complete",
      // accessor: "business",
      Cell: ({ cell }) => {
        const business = cell.row.original?.business;
        return <span>{business?.kycDone ? 'YES' : 'NO'} </span>;
      },
    },
  ];

  const printData = tableData.map((item) => ({
    "Account Name": item?.accountName || "",
    "Account Number": item?.accountNumber || "",
    Bank: item?.bank || "",
    "Business Owner": `${item?.users[0]?.firstname} ${item?.users[0]?.lastname}`,
    "Phone number": `${item?.business?.businessMobile} / ${item?.users[0]?.mobile}`,
    Email: item?.business?.email || "",
    STATUS: item?.business?.status,
    'KYC COMPLETE': item?.business?.kycDone ? 'YES' : 'NO',
  }));



  return (
    <AppPage pageTitle="Bank Account List">
      <MimaButton
        title={`Download Bank Account List`}
        onClick={() => {
          downloadXlsx2(printData);
        }}
        mb={2}
      />
      <MimaTable
        tableData={tableData}
        tableColumns={tableColumns}
        searchPlaceholder="Search"
        searchVariant="wide"
        totalItems={data?.data?.totalBankAccounts}
        onLimitChange={onLimitChange}
        isLoading={isLoading}
        isFetching={isFetching}
        limit={limit}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        setSearchQuery={setSearchQuery}
      />
    </AppPage>
  );
};

export default BankAccountList;
